import { getPath } from '@/router/common'

const baseUrl = {
  title: '更新记录',
  path: 'updateRecord'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'updateRecord_Index',
    component: () => import(/* webpackChunkName: "updateRecord_Index" */ '@/views/updateRecord/index/index.vue'),
    meta: {
      title: '更新记录'
    }
  }
]
